import { useState } from 'react'

const useCheckoutContext = () => {
  const [checkoutContext, setCheckoutContext] = useState({
    paymentItems: [],
    paymentPlans: [],
    paymentVouchers: [],
    totalToPay: 0,
    totalPaid: 0,
  })

  return { checkoutContext, setCheckoutContext }
}

export default useCheckoutContext
